<template>
    <div class="text-center py-3">
        <div v-if="currentPromotion">
            <img :src="currentPromotion.ImageUrl" style="width: 100%; max-width: 800px;" />
            <div class="mt-4 mx-auto" style="width: 100%; max-width: 800px;">
                <h5><strong>{{ currentPromotion.Description }}</strong></h5>
                <p>
                    {{ currentPromotion.FullDescription }}
                </p>
                <div v-if="currentPromotion.condsData && currentPromotion.condsData.length > 0">
                    <p class="mb-2" v-for="cond in currentPromotion.condsData" :key="cond.ApplyFromAmount">
                        <strong style="color: #529420;">+{{ cond.PercentDiscount }}%&nbsp;</strong> <strong>bonus
                            credits</strong>
                        for purchases from <strong style="color: #19B5FE;">${{ cond.ApplyFromAmount }}</strong>
                    </p>
                </div>

                <div class="mt-6">
                    <button class="primary-button-style-2026 px-12" type="button" @click="$router.push('/payment-management')">
                        Recharge
                    </button>
                </div>
            </div>
        </div>
        <button v-if="activePromotions.length > 1" @click="prev" class="button-prev-promotion" :disabled="isFirst"><i class="ri-arrow-left-line"></i></button>
        <button v-if="activePromotions.length > 1" @click="next" class="button-next-promotion" :disabled="isLast"><i class="ri-arrow-right-line"></i></button>
    </div>
</template>

<script>

import promotionApi from '@/api/promotionApi';
import { EXECUTE_RESULT } from "@/constant/baseConstant";
export default {
    data() {
        return {
            activePromotions: [],
            currentIndex: 0,
            loop: false
        }
    },
    computed: {
        currentPromotion() {
            return this.activePromotions[this.currentIndex] || null
        },
        isFirst() {
            return this.currentIndex === 0
        },
        isLast() {
            return this.currentIndex === this.activePromotions.length - 1
        }
    },
    mounted() {
        this.getActivePromotions();
    },
    methods: {
        async getActivePromotions() {
            const res = await promotionApi.getActivePromotions();
            if (res) {
                const data = res.data;
                if (data.result === EXECUTE_RESULT.SUCCESS) {
                    this.activePromotions = data.data.map(item => {
                        const { CondsJson, ...rest } = item;
                        return { ...rest, condsData: JSON.parse(CondsJson || "[]") };
                    });
                }
            }
        },
        next() {
            if (this.currentIndex < this.activePromotions.length - 1) {
                this.currentIndex++
            } else if (this.loop) {
                this.currentIndex = 0
            }
        },

        prev() {
            if (this.currentIndex > 0) {
                this.currentIndex--
            } else if (this.loop) {
                this.currentIndex = this.activePromotions.length - 1
            }
        },
    }
}
</script>

<style lang="scss">
.button-prev-promotion,
.button-next-promotion {
    margin-right: 10px;
    background: #0f0f0fb0;
    color: #fff;
    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    border-radius: 50px;
    position: absolute;
    width: 50px;
    aspect-ratio: 1 / 1;
    display: flex;
    align-items: center;
    justify-content: center;
}
.button-prev-promotion{
    left: 5px;
    top: 60%;
}
.button-next-promotion{
    right: 5px;
    top: 60%;
}
</style>